import * as angular from 'angular';
import * as moment from 'moment';
import { DirectiveDefinition } from './directiveDefinition';

class WtDateTimeFormatController implements angular.IController {
    
    ngModel: angular.INgModelController;
    
    static $inject = ['$filter', '$element'];
    constructor(private _$filter: angular.IFilterService,
        private _$element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        const modelCtrl = this._$element.controller('ngModel');

        if (modelCtrl) {
            modelCtrl.$formatters.push(input => {
                if (input == null) {
                    return;
                }
                const formatted = this.format(input);
                return formatted;
            });
            modelCtrl.$parsers.push(input => {
                if (input == null) {
                    return;
                }
                const formatted = this.format(input);
                modelCtrl.$setViewValue(formatted);
                modelCtrl.$render();
                return formatted;
            });
        }
    }

    private format(input: string): string {
        const m = moment(input);
        const formatted = this._$filter('date')(m.toDate(), 'yyyy-MM-dd HH:mm');
        return formatted;
    }
}

export const WtDateTimeFormatDirective: DirectiveDefinition = {
    directiveId: 'wtDateTimeFormat',
    restrict: 'A',
    controller: WtDateTimeFormatController,
    scope: {
        ngModel: '=?'
    }
};